import { Validator } from '@vista-digital/validator';
import { defaultQuickNavigatorAssets, quickNavigatorAssetsValidator } from './assets';
import { defaultQuickNavigatorCdnOptions, quickNavigatorCdnOptionsValidator } from './cdn-options';
import { defaultQuickNavigatorConfig, quickNavigatorConfigValidator } from './config';
import { defaultQuickNavigatorDisplayText, quickNavigatorDisplayTextValidator } from './display-text';
import { quickNavigatorEventsValidator } from './events';
export const defaultQuickNavigatorProps = {
    config: defaultQuickNavigatorConfig,
    displayText: defaultQuickNavigatorDisplayText,
    assets: defaultQuickNavigatorAssets,
    cdnOptions: defaultQuickNavigatorCdnOptions,
    events: {}
};
export const quickNavigatorPropsValidator = Validator.object({
    config: quickNavigatorConfigValidator,
    displayText: quickNavigatorDisplayTextValidator,
    assets: quickNavigatorAssetsValidator,
    cdnOptions: quickNavigatorCdnOptionsValidator,
    events: quickNavigatorEventsValidator
});
//# sourceMappingURL=props.js.map